import { Box, Button, Grid } from "@mui/material";
import React, { useEffect } from "react";
import "./QuizFil.css";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/logo_quick-learning-tool.png";
import Bubble from "../../assets/speech-bubble_blue.png";
import Char from "../../assets/character.png";
import QuizButton from "./QuizButton";
import { useSelector, useDispatch } from "react-redux";
import { unsetScore } from "../../features/scoreCounter/scoreSlice";
import Swal from "sweetalert2";

function QuizFil() {
  const navigate = useNavigate();
  const { score } = useSelector((state) => state.score);
  const dispatch = useDispatch();

  useEffect(() => {
    if (score > 0) {
      dispatch(unsetScore());
    }
  }, []);

  const handleNext = () => {
    if (score === 0) {
      Swal.fire({
        icon: "error",
        title: "Walang piniling kahon",
        text: "Pakipili ng mga kahon kung OO ang sagot mo sa mga ito",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      return;
    } else {
      navigate("/results/Fil");
    }
  };

  const handleLanguage = () => {
    navigate("/");
  };

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={3} className="left-card">
          <Box className="img-container">
            <img src={Logo} alt="Logo" className="logo-img" />
          </Box>
          <Box sx={{ marginBottom: ".5rem" }}>
            <Button
              sx={{
                backgroundColor: "#1ec2f0",
                color: "#fff",
                fontSize: "1.2rem",
                textTransform: "none",
                padding: ".7rem",
                borderRadius: "1.5rem",
                "&:hover": {
                  backgroundColor: "#1ec2f0", // Set it to the same value as the default
                },
              }}
              onClick={() => handleLanguage()}
            >
              To English Ver.
            </Button>
          </Box>
          <Box className="instruction-card">
            <p className="instruction-title">Gabay</p>
            <p className="instruction-text">
              Subukan ang quiz na ito para malaman ang iyong level of
              empowerment bilang financial customer.
            </p>
            <p className="instruction-text">
              Sa bandang kanan ay serye ng mga tanong na nagpapakita ng
              kaalaman, pananaw, at mga aksyon kaugnay sa buhay pinansyal.
            </p>
            <p className="instruction-text">
              I-click ang kahon kung ang iyong sagot ay OO sa tanong.
            </p>
            <p className="instruction-text">
              Kapag tapos ka na sa pagsagot sa mga tanong, i-click ang Next na
              button.
            </p>
          </Box>
        </Grid>
        <Grid item xs={12} md={9} className="right-card">
          <Grid container>
            <Grid item xs={12} md={9}>
              <Box className="right-card-header">
                <Box className="img-container-bubble">
                  <p className="header-title">
                    Isa ka bang empowered financial customer?
                  </p>
                  <img src={Bubble} alt="bubble" className="bubble-img" />
                </Box>
              </Box>
              <Box className="item-container">
                <QuizButton>
                  Alam mo ba kung anong mga pagpipilian ang mayroon sa financial
                  market?
                </QuizButton>
                <QuizButton>
                  Alam at kaya mo ba kung paano gamitin ang sistema ng
                  pagbibigay puna o reklamo?
                </QuizButton>
                <QuizButton>
                  Alam mo ba kung ano ang dapat mong asahan mula sa isang
                  financial service provider?
                </QuizButton>
                <QuizButton>
                  Nauunawaan mo ba kung paano gamitin ang mga serbisyong
                  pinansyal para sa isang layunin?
                </QuizButton>
                <QuizButton>
                  Kumpyansa ka ba sa iyong kakayahang pumili?
                </QuizButton>
                <QuizButton>
                  Handa ka bang magbigay ng feedback o reklamo?
                </QuizButton>
                <QuizButton>
                  Inaasahan mo ba ang magandang pagtrato mula sa mga financial
                  service providers at mga tauhan nito?
                </QuizButton>
                <QuizButton>
                  Nararamdaman mo ba ang kakayahan na gamitin ang mga serbisyo
                  sa pinansyal?
                </QuizButton>
                <QuizButton>
                  Pinagkukumpara mo ba ang mga produkto at serbisyong mayroon sa
                  financial market?
                </QuizButton>
                <QuizButton>
                  Nagbibigay ka ba ng feedback at nagrereklamo kapag kailangan?
                </QuizButton>
                <QuizButton>
                  Naranasan mo na ba ang pagtrato nang may respeto mula sa
                  financial service providers?
                </QuizButton>
                <QuizButton>
                  Nakakuha at nakagamit ka na ba ng angkop na mga serbisyong
                  pinansyal?
                </QuizButton>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  flexDirection: "column",
                }}
              >
                <Box className="img-container">
                  <img src={Char} alt="Char" className="logo-img" />
                </Box>
                <Button className="quiz-button" onClick={() => handleNext()}>
                  Sunod
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default QuizFil;
